var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"icon-action",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.$emit('click')}}},[_c('icon',{attrs:{"icon":_vm.icon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }